export const REACT_QUERY_KEYS = {
    ROUTE: "route",
    VIEW_ROUTE : "view_route",
    RECENT_SALES : "recent_sales",
    VIEW_CUSTOMER: 'view_customer',
    VIEW_GRN: 'view_grn',
    VIEW_PAYMENTRECEIPT:"view_payment_receipt",
    VIEW_SALESQUOTATION:"view_salse_quatation",
    VIEW_SALESORDER:"view_salse_order",
    STOCK_TRANSFER:"stock_transfer",
    STOCK_ISSUE:"stock_Issue",
    VIEWPAYMENT_RECEIPT:"siew_payment_receipt",
    VEHICLE_MASTER:"vehicle_master",
    SERVICE_PACKAGE:"service_package",
    CREDIT_AND_DEBIT : "add_credit_and_debit",
    ADD_CUSTOMER:"add_customer",
    ADD_SUPPLIER:"add_supplier",
    ADD_SALSEREP:"add_salesRep",
    ADD_SALSE_QUOTATION:"sales_quotation",
    ADD_EXPENSES_TYPE:"add_expenses_type",
    ADD_EXPENSES:"add_expenses",
    ADD_STOCK_ISSUE:"add_stock_issue",
    STOCK_ISSUE_TYPE:"stock_issue_type",
    Sub_CATEGORY:"sub_category",
    ADD_ITEM_MASTER:"add_itemMaster",
    EXPENSE_CATEGIRY:"expense_category",
    EXPENSES:"expenses",
    JOUNAL_TYPES:"jounal_types",
    SINGLE_ENTRY:"single_entry",
    VIEW_EXPENSE:"view_expense",
    ADD_EXPENSE:"add_expense",
    ADD_CREDIT_AND_DEBIT: "add_credit_and_debit",
    LAST_GEN_DATE:"last_gen_date",
    VIEW_RETURN_CHEQUE_PAYMENT:"view_cheque_return_payment",
    VIEW_STOCK_IN:"view_stock_in",
    ADD_BOOKING:"Add_Room",
    VIEW_BOOKING:"View Booking",
    VIEW_ITEM_MASTER:'view_item_master',
    VIEW_UNCOMPLETE_KOT:'view_uncomplete_kot',
    VIEW_DELIVERY_LIST:'vew_delivery_list',
    ADD_LOCATION_DETAILS:"add_location_datails",

}
